import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BlockComponent} from './block.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [BlockComponent],
  exports: [BlockComponent]
})
export class BlockModule { }



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/layout/block/block.module.ts